import { Component } from '@angular/core';
import { Nav, NavController } from 'ionic-angular';
import { SlideContentPage } from '../slidecontent/slidecontent'
import { HomePage } from '../home/home';

import { HttpClient } from '@angular/common/http';
import { AppConfigProvider } from '../../providers/app-config/app-config';
import { Storage } from '@ionic/storage';

@Component({
  selector: 'page-list',
  templateUrl: 'list.html'
})
export class ListPage {
  pages: Array<{ title: string; component: any }>;
  portfolios: any[];
  user_id: any;

  constructor(
    public navCtrl: NavController,
    public nav: Nav,
    private http: HttpClient,
    private appConfig: AppConfigProvider,
    private storage: Storage
  ) {
    this.pages = [{ title: 'Home', component: HomePage }];

    this.portfolios = [];

    this.storage.get('user_id').then((val) => {
      this.user_id = val;
      this.getPortfolio();
    });
  }

  openPage(page) {
    this.navCtrl.push(page.component);
  }

  openSlide(row) {
    this.navCtrl.push(SlideContentPage, {
      subportfolio_id: row.id,
      img: row.background,
      title: row.title
    });
  }

  getPortfolio() {
    this.http
      .post(this.appConfig.apiUrl() + 'index.php/api/subportfolio/mySubPortfolio', {
        token: 'token',
        user_id: this.user_id,
        app_key: this.appConfig.appKey()
      })
      .subscribe(
        (res: any) => {
          // console.log(res);
          let data = res.subportfolios;

          for (let pfolio of data) {
            let temp = {
              id: pfolio.id,
              title: pfolio.title,
              background: pfolio.feature_image
            };
            this.portfolios.push(temp);
          }
        },
        err => {
          console.log('Error request' + JSON.stringify(err));
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/pages/list/list.ts